import { defineStore } from "pinia";
import { computed, reactive, ref, watch } from "vue";
import { getUserInfo, getVipInfo } from "@/csdPublic/user";
import { setStorage, getStorage, removeStorage } from "@/utils/storage";
import { openLoginDialog } from "@/components/content/loginDialog/login";
import { formatTime } from "@/csdPublic/utils/index.js";
import router from "@/router";

import {
  showMessageBox,
  messageBoxContent,
} from "@/components/content/MessageBox/messageBox.ts";

const publicStore = defineStore(
  "publicStore",
  () => {
    const isLogin = ref(!!getStorage("token"));
    const tryOut = ref(false);

    const isExperience = ref(false);
    const userInfo = reactive({
      nickName: "--",
      uid: "000000",
      userName: "--",
      avatar: null,
      bind_phone: null, // 绑定手机号
      unionid: null, // 微信unionid
    });
    const vipInfo = reactive({
      expiry: "--", // 过期时间
      expiryDay: 0, // 到期天数
      permanent: 0, // 0: 不是永久会员 1: 是永久会员
      points: 0, // 积分（点数）
      status: 0, // 0: 未开通 1: 已开通 2: 已过期
      soft_edition: -1,
    });

    const isVip = computed(() => vipInfo.status === 1 && isLogin.value);
    watch(isLogin, () => {
      if (!isLogin.value) {
        // 水印的判断
        userInfo.uid = "";
      }
    });
    const changeUserInfo = async () => {
      if (!getStorage("token")) {
        return;
      }
      try {
        const res = await getUserInfo();
        userInfo.nickName = res.nickname;
        userInfo.uid = res.uid;
        userInfo.userName = res.username;
        userInfo.avatar = res.avatar;
        userInfo.bind_phone = res.bind_phone;
        userInfo.unionid = res.unionid;
      } catch (e: any) {
        if (e.code == 403) {
          if (!isLogin.value) return;
          ElMessage.error("登录信息已过期，请重新登录");
          openLoginDialog();
          isLogin.value = false;
          removeStorage("token");
        }
      }
    };

    const changeVipInfo = async () => {
      if (!getStorage("token")) {
        const vipOri = {
          expiry: "--", // 过期时间
          expiryDay: 0, // 到期天数
          permanent: 0, // 0: 不是永久会员 1: 是永久会员
          points: 0, // 积分（点数）
          status: 0, // 0: 未开通 1: 已开通 2: 已过期
          soft_edition: -1,
        };
        Object.keys(vipOri).forEach((key: any) => {
          (vipInfo as any)[key] = (vipOri as any)[key];
        });
        return;
      }
      try {
        const res = await getVipInfo();
        vipInfo.expiry = res.expiry;
        vipInfo.expiryDay = res.expiry_day;
        vipInfo.permanent = res.permanent;
        vipInfo.points = res.points;
        vipInfo.status = res.status;
        vipInfo.soft_edition = res.status === 1 ? res.soft_edition : -1;
        let nowTime = formatTime(1).split("-").join("");
        const endTime = res.expiry.split(" ")[0];
        const endTimeValue = endTime.split("-").join("");
        const vipExpiryRemind = getStorage("vipExpiryRemind");
        // 弹窗提醒 vip 即将到期，一天一次
        if (
          vipInfo.status === 1 &&
          endTimeValue - nowTime >= 0 &&
          endTimeValue - nowTime <= 7 &&
          (!vipExpiryRemind || nowTime - (vipExpiryRemind as any) > 0)
        ) {
          messageBoxContent.value = {
            title: "",
            content: `会员权益将在 <span style='color: #5865F2; font-weight:bold;'>${endTime}</span> 到期，剩余<span style='color: #5865F2;font-weight:bold;'>${res.points}积分</span>将到期清零，现在续费立即延长会员权益`,
            content_type: "html", // 'text' | 'html
            confirm: () => {
              showMessageBox.value = false;
              router.push("/member");
            },
            cancel: () => {
              showMessageBox.value = false;
            },
            confirmText: "前往续费",
            cancelText: "关闭",
          };
          showMessageBox.value = true;
          setStorage("vipExpiryRemind", nowTime);
        }
        // showMessageBox,
        //   messageBoxContent
      } catch (e: any) {
        if (e.code == 403) {
          if (!isLogin.value) return;
          ElMessage.error("登录信息已过期，请重新登录");
          openLoginDialog();
          isLogin.value = false;
          removeStorage("token");
        }
      }
    };

    return {
      isLogin,
      isExperience,
      userInfo,
      vipInfo,
      isVip,
      tryOut,
      changeUserInfo,
      changeVipInfo,
    };
  },
  { persist: true }
);

export default publicStore;
